import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toHandlers as _toHandlers, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f0e34684"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("template", null, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont team-admin-nav-icon-zhongduanbiaoshi",
    style: {"color":"var(--cm-color-text-regular)","font-weight":"normal","font-size":"18px"}
  })
], -1))
const _hoisted_3 = { style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"14px"} }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont cm-icon-right" })
], -1))
const _hoisted_8 = {
  key: 0,
  style: {"line-height":"1rem","font-size":"14px","color":"var(--cm-color-text-regular)"}
}

import UploadImage from './UploadImage.vue'
import UploadFile from './UploadFile.vue'
import { computed, PropType } from 'vue'
import { useCmFormDefaultPlaceholder } from './useCmFormDefaultPlaceholder'
import DynamicFormItem from './DynamicFormItem.vue'
import DynamicFormTable from './DynamicFormTable.vue'
import { getFormItemRules, getLabel, getValue } from '@/hooks'
import { FormType, FormItem, GlobalOpt } from './types'
import _FormItem from 'element-plus/lib/el-form-item'
import { formLabelStyle } from './globalOpt'
import { TableOpt } from '../cmTable/types'

export default /*#__PURE__*/_defineComponent({
  __name: 'FormItem',
  props: {
  formItem: {
    type: Object as PropType<FormItem<any, any>>,
    required: true,
  },
  modelValue: {
    type: Object,
    required: true,
  },
  prop: {
    type: String,
  },
  /** 与父级 el-form :model 对应的校验路径（如 strategy.process_infos）；不传则与 prop 一致 */
  validateProp: {
    type: String,
    default: undefined,
  },
  tableOpt: {
    type: Object as PropType<TableOpt>,
  },
  globalOpt: {
    type: Object as PropType<GlobalOpt>,
  },
},
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const { placeholderInput: phInput, placeholderSelect: phSelect } =
  useCmFormDefaultPlaceholder()

const formItemTyped = computed(() => props.formItem as FormItem<any, any>)

const placeholderInput = computed(() => phInput(formItemTyped.value))
const placeholderSelect = computed(() => phSelect(formItemTyped.value))

const form = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  },
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_segmented = _resolveComponent("el-segmented")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!

  return (!__props.formItem.hidden?.())
    ? (_openBlock(), _createBlock(_component_el_col, _normalizeProps(_mergeProps({ key: 0 }, { ...(__props.formItem?.colOpt ?? __props.globalOpt?.colOpt ?? { span: 12 }) })), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, __props.prop + '-top-label', {
            formItem: __props.formItem,
            prop: __props.prop
          }),
          _createVNode(_component_el_form_item, _mergeProps({
            prop: __props.validateProp ?? __props.prop
          }, { ...__props.globalOpt?.formItemOpt, ...__props.formItem.formItemOpt }, {
            rules: _unref(getFormItemRules)(__props.globalOpt?.required, __props.formItem)
          }), {
            label: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, __props.prop + '-label', {
                  formItem: __props.formItem,
                  label: __props.formItem.label,
                  prop: __props.prop
                }, () => [
                  (!__props.formItem.hiddenAllLabel)
                    ? (_openBlock(), _createElementBlock("div", _mergeProps({
                        key: 0,
                        class: "gap-x-4 cm-ui-mr10",
                        style: [{"display":"flex","align-items":"center","flex":"auto"}, __props.formItem.labelStyle]
                      }, __props.formItem.labelOpt), [
                        (!__props.formItem.hiddenLabel)
                          ? (_openBlock(), _createElementBlock("div", _mergeProps({
                              key: 0,
                              class: "cm-label cm-required-right",
                              style: _unref(formLabelStyle)
                            }, __props.formItem.labelStyle), _toDisplayString(__props.formItem.label), 17))
                          : _createCommentVNode("", true),
                        (__props.formItem.tipContent)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, _mergeProps({
                              key: 1,
                              effect: __props.formItem.effect||'light',
                              placement: __props.formItem.placement||'bottom-start'
                            }, __props.formItem.tipOpt, {
                              content: __props.formItem.tipContent,
                              offset: 0
                            }), {
                              content: _withCtx(() => [
                                _createTextVNode(_toDisplayString(__props.formItem.tipContent), 1)
                              ]),
                              default: _withCtx(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            }, 16, ["effect", "placement", "content"]))
                          : _createCommentVNode("", true)
                      ], 16))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(__props.formItem.customClass),
                style: {"width":"100%","box-sizing":"border-box"}
              }, [
                _renderSlot(_ctx.$slots, "default", {
                  prop: __props.prop,
                  formItem: __props.formItem
                }, () => [
                  (__props.formItem.type === _unref(FormType).Upload)
                    ? (_openBlock(), _createBlock(UploadImage, {
                        key: 0,
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value[__props.prop]) = $event)),
                        globalOpt: __props.formItem.globalOpt
                      }, null, 8, ["modelValue", "globalOpt"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).UploadFile)
                    ? (_openBlock(), _createBlock(UploadFile, {
                        key: 1,
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value[__props.prop]) = $event)),
                        globalOpt: __props.formItem.globalOpt
                      }, null, 8, ["modelValue", "globalOpt"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).Dynamic)
                    ? (_openBlock(), _createBlock(DynamicFormItem, {
                        key: 2,
                        modelValue: form.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form).value = $event)),
                        dynamicFormItem: __props.formItem,
                        prop: __props.prop,
                        globalOpt: __props.formItem.globalOpt
                      }, null, 8, ["modelValue", "dynamicFormItem", "prop", "globalOpt"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).DynamicTable)
                    ? (_openBlock(), _createBlock(DynamicFormTable, {
                        key: 3,
                        modelValue: form.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form).value = $event)),
                        dynamicFormItem: __props.formItem,
                        prop: __props.prop,
                        tableOpt: __props.formItem.tableOpt,
                        globalOpt: __props.formItem.globalOpt
                      }, null, 8, ["modelValue", "dynamicFormItem", "prop", "tableOpt", "globalOpt"]))
                    : _createCommentVNode("", true),
                  (!__props.formItem.type)
                    ? (_openBlock(), _createBlock(_component_el_input, _mergeProps({
                        key: 4,
                        type: __props.formItem.inputType,
                        modelModifiers: __props.formItem.modelModifiers || {},
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value[__props.prop]) = $event)),
                        disabled: __props.formItem.disabled?.(),
                        readonly: __props.formItem.readonly?.(),
                        placeholder: placeholderInput.value
                      }, _toHandlers(__props.formItem.events ?? {}), __props.formItem.inputOpt), _createSlots({ _: 2 }, [
                        (__props.formItem.prependSlot)
                          ? {
                              name: "prepend",
                              fn: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "prepend")
                              ]),
                              key: "0"
                            }
                          : undefined,
                        (__props.formItem.appendSlot)
                          ? {
                              name: "append",
                              fn: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "append")
                              ]),
                              key: "1"
                            }
                          : undefined
                      ]), 1040, ["type", "modelModifiers", "modelValue", "disabled", "readonly", "placeholder"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).InputNumber)
                    ? (_openBlock(), _createBlock(_component_el_input_number, _mergeProps({ key: 5 }, _toHandlers(__props.formItem.events ?? {}), {
                        placeholder: placeholderInput.value,
                        modelModifiers: __props.formItem.modelModifiers || {},
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value[__props.prop]) = $event))
                      }, __props.formItem.inputNumOpt, {
                        disabled: __props.formItem.disabled?.()
                      }), null, 16, ["placeholder", "modelModifiers", "modelValue", "disabled"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).Cascader)
                    ? (_openBlock(), _createBlock(_component_el_cascader, _mergeProps({
                        key: 6,
                        modelModifiers: __props.formItem.modelModifiers || {},
                        placeholder: placeholderSelect.value,
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value[__props.prop]) = $event)),
                        options: __props.formItem.dictData,
                        props: __props.formItem.props,
                        disabled: __props.formItem.disabled?.()
                      }, _toHandlers(__props.formItem.events ?? {}), __props.formItem.cascaderOpt), null, 16, ["modelModifiers", "placeholder", "modelValue", "options", "props", "disabled"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).Select)
                    ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
                        key: 7,
                        modelModifiers: __props.formItem.modelModifiers || {}
                      }, _toHandlers(__props.formItem.events ?? {}), {
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value[__props.prop]) = $event)),
                        placeholder: placeholderSelect.value
                      }, __props.formItem.selectOpt, {
                        disabled: __props.formItem.disabled?.()
                      }), {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formItem.dictData, (opt) => {
                            return (_openBlock(), _createBlock(_component_el_option, _mergeProps({
                              key: opt[_unref(getValue)(__props.formItem.props)],
                              disabled: opt.disabled,
                              ref_for: true
                            }, opt.optionOpt, {
                              label: opt[_unref(getLabel)(__props.formItem.props)],
                              value: opt[_unref(getValue)(__props.formItem.props)]
                            }), {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(opt[_unref(getLabel)(__props.formItem.props)]) + " ", 1),
                                _createElementVNode("span", _hoisted_3, _toDisplayString(opt.subtitle), 1)
                              ]),
                              _: 2
                            }, 1040, ["disabled", "label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 16, ["modelModifiers", "modelValue", "placeholder", "disabled"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).SelectGroup)
                    ? (_openBlock(), _createBlock(_component_el_select, _mergeProps({
                        key: 8,
                        modelModifiers: __props.formItem.modelModifiers || {}
                      }, __props.formItem.selectGroupOpt, _toHandlers(__props.formItem.events ?? {}), {
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value[__props.prop]) = $event)),
                        disabled: __props.formItem.disabled?.(),
                        placeholder: placeholderSelect.value
                      }), {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formItem.dictData, (group) => {
                            return (_openBlock(), _createBlock(_component_el_option_group, {
                              key: group.label,
                              label: group.label
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item?.dictData ?? group.dictData, (opt) => {
                                  return (_openBlock(), _createBlock(_component_el_option, _mergeProps({
                                    modelModifiers: __props.formItem.modelModifiers || {}
                                  }, _toHandlers(opt.events ?? {}), { ref_for: true }, opt.opt, {
                                    key: opt[_unref(getValue)(group.props)],
                                    disabled: opt.disabled,
                                    label: opt[_unref(getLabel)(group.props)],
                                    value: opt[_unref(getValue)(group.props)]
                                  }), null, 16, ["modelModifiers", "disabled", "label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 16, ["modelModifiers", "modelValue", "disabled", "placeholder"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).Rate)
                    ? (_openBlock(), _createBlock(_component_el_rate, _mergeProps({
                        key: 9,
                        modelModifiers: __props.formItem.modelModifiers || {}
                      }, _toHandlers(__props.formItem.events ?? {}), {
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value[__props.prop]) = $event))
                      }, __props.formItem.rateOpt), null, 16, ["modelModifiers", "modelValue"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).TimeSelect)
                    ? (_openBlock(), _createBlock(_component_el_time_select, _mergeProps({
                        key: 10,
                        modelModifiers: __props.formItem.modelModifiers || {}
                      }, _toHandlers(__props.formItem.events ?? {}), {
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value[__props.prop]) = $event)),
                        disabled: __props.formItem.disabled?.(),
                        "aria-label": `Pick a ${__props.formItem.dateType || _unref(FormType).Date}`,
                        placeholder: placeholderSelect.value,
                        style: {"width":"100%"}
                      }, __props.formItem.timeSelectOpt), null, 16, ["modelModifiers", "modelValue", "disabled", "aria-label", "placeholder"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).Date)
                    ? (_openBlock(), _createBlock(_component_el_date_picker, _mergeProps({
                        key: 11,
                        modelModifiers: __props.formItem.modelModifiers || {}
                      }, _toHandlers(__props.formItem.events ?? {}), {
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value[__props.prop]) = $event)),
                        type: __props.formItem.dateType ?? __props.formItem.Date,
                        disabled: __props.formItem.disabled?.(),
                        "aria-label": `Pick a ${__props.formItem.dateType || _unref(FormType).Date}`,
                        placeholder: placeholderSelect.value,
                        style: {"width":"100%"}
                      }, __props.formItem.dateOpt), null, 16, ["modelModifiers", "modelValue", "type", "disabled", "aria-label", "placeholder"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).Segmented)
                    ? (_openBlock(), _createBlock(_component_el_segmented, _mergeProps({
                        key: 12,
                        modelModifiers: __props.formItem.modelModifiers || {}
                      }, _toHandlers(__props.formItem.events ?? {}), {
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value[__props.prop]) = $event)),
                        options: __props.formItem.options
                      }, __props.formItem.segmentedOpt, {
                        disabled: __props.formItem.disabled?.()
                      }), null, 16, ["modelModifiers", "modelValue", "options", "disabled"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).Time)
                    ? (_openBlock(), _createBlock(_component_el_time_picker, _mergeProps({
                        key: 13,
                        modelModifiers: __props.formItem.modelModifiers || {}
                      }, _toHandlers(__props.formItem.events ?? {}), {
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value[__props.prop]) = $event)),
                        "aria-label": __props.formItem.label,
                        disabled: __props.formItem.disabled?.()
                      }, __props.formItem.timeOpt, {
                        placeholder: placeholderSelect.value,
                        style: {"width":"100%"}
                      }), null, 16, ["modelModifiers", "modelValue", "aria-label", "disabled", "placeholder"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).Switch)
                    ? (_openBlock(), _createBlock(_component_el_switch, _mergeProps({
                        key: 14,
                        modelModifiers: __props.formItem.modelModifiers || {}
                      }, _toHandlers(__props.formItem.events ?? {}), {
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value[__props.prop]) = $event))
                      }, __props.formItem.switchOpt, {
                        disabled: __props.formItem.disabled?.()
                      }), null, 16, ["modelModifiers", "modelValue", "disabled"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).CheckboxGroup)
                    ? (_openBlock(), _createBlock(_component_el_checkbox_group, _mergeProps({
                        key: 15,
                        modelModifiers: __props.formItem.modelModifiers || {},
                        disabled: __props.formItem.disabled?.()
                      }, _toHandlers(__props.formItem.events ?? {}), {
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value[__props.prop]) = $event))
                      }, __props.formItem.checkboxGroupOpt), {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formItem.dictData, (opt) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, _mergeProps({
                              modelModifiers: __props.formItem.modelModifiers || {}
                            }, _toHandlers(opt.events), {
                              key: opt[_unref(getValue)(__props.formItem.props)],
                              ref_for: true
                            }, __props.formItem.checkboxOpt, {
                              disabled: opt.disabled,
                              value: opt[_unref(getValue)(__props.formItem.props)],
                              label: opt[_unref(getValue)(__props.formItem.props)]
                            }), {
                              default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, __props.prop+'-'+opt[_unref(getValue)(__props.formItem.props)]+'-checkbox', {
                                  opt: {opt,label:opt[_unref(getLabel)(__props.formItem.props)],value:opt[_unref(getValue)(__props.formItem.props)]}
                                }, () => [
                                  _createTextVNode(_toDisplayString(opt[_unref(getLabel)(__props.formItem.props)]) + " ", 1),
                                  _createElementVNode("span", null, _toDisplayString(opt.subtitle), 1)
                                ])
                              ]),
                              _: 2
                            }, 1040, ["modelModifiers", "disabled", "value", "label"]))
                          }), 128))
                        ]),
                        _: 3
                      }, 16, ["modelModifiers", "disabled", "modelValue"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).Radio)
                    ? (_openBlock(), _createBlock(_component_el_radio_group, _mergeProps({
                        key: 16,
                        modelModifiers: __props.formItem.modelModifiers || {}
                      }, _toHandlers(__props.formItem.events ?? {}), {
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value[__props.prop]) = $event)),
                        disabled: __props.formItem.disabled?.()
                      }, __props.formItem.radioGroupOpt), {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formItem.dictData, (opt, optIndex) => {
                            return (_openBlock(), _createBlock(_component_el_radio, _mergeProps({
                              modelModifiers: __props.formItem.modelModifiers || {}
                            }, _toHandlers(opt.events), {
                              key: opt[_unref(getValue)(__props.formItem.props)],
                              disabled: opt.disabled,
                              ref_for: true
                            }, opt.radioOpt, {
                              label: opt[_unref(getValue)(__props.formItem.props)],
                              value: opt[_unref(getValue)(__props.formItem.props)]
                            }), {
                              default: _withCtx(() => [
                                (__props.formItem.radioHtmlText)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "",
                                      innerHTML: __props.formItem.radioHtmlText(opt[_unref(getLabel)(__props.formItem.props)],opt[_unref(getValue)(__props.formItem.props)],opt.subtitle,optIndex, opt)
                                    }, null, 8, _hoisted_4))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(opt[_unref(getLabel)(__props.formItem.props)]) + " ", 1),
                                      _createElementVNode("span", null, _toDisplayString(opt.subtitle), 1)
                                    ], 64))
                              ]),
                              _: 2
                            }, 1040, ["modelModifiers", "disabled", "label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 16, ["modelModifiers", "modelValue", "disabled"]))
                    : _createCommentVNode("", true),
                  (__props.formItem.type === _unref(FormType).RadioCm)
                    ? (_openBlock(), _createBlock(_component_el_radio_group, _mergeProps({
                        key: 17,
                        modelModifiers: __props.formItem.modelModifiers || {},
                        class: "cm-radio-group"
                      }, _toHandlers(__props.formItem.events ?? {}), {
                        modelValue: form.value[__props.prop],
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value[__props.prop]) = $event)),
                        disabled: __props.formItem.disabled?.()
                      }, __props.formItem.radioGroupOpt), {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formItem.dictData, (opt) => {
                            return (_openBlock(), _createBlock(_component_el_radio, _mergeProps({
                              modelModifiers: __props.formItem.modelModifiers || {},
                              class: "cm-radio"
                            }, _toHandlers(opt.events), {
                              key: opt[_unref(getValue)(__props.formItem.props)],
                              disabled: opt.disabled,
                              ref_for: true
                            }, opt.radioOpt, {
                              label: opt[_unref(getValue)(__props.formItem.props)],
                              value: opt[_unref(getValue)(__props.formItem.props)]
                            }), {
                              default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, __props.prop+'-radio-title', {
                                  title: opt[_unref(getLabel)(__props.formItem.props)],
                                  item: opt
                                }, () => [
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(opt[_unref(getLabel)(__props.formItem.props)]), 1),
                                  (opt.subTitle)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "sub-title",
                                        title: opt.subTitle
                                      }, _toDisplayString(opt.subTitle), 9, _hoisted_6))
                                    : _createCommentVNode("", true)
                                ]),
                                _hoisted_7
                              ]),
                              _: 2
                            }, 1040, ["modelModifiers", "disabled", "label", "value"]))
                          }), 128))
                        ]),
                        _: 3
                      }, 16, ["modelModifiers", "modelValue", "disabled"]))
                    : _createCommentVNode("", true)
                ]),
                (__props.formItem.tip)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(__props.formItem.tip), 1))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, __props.prop + '-footer', {
                  prop: __props.prop,
                  formItem: __props.formItem
                })
              ], 2)
            ]),
            _: 3
          }, 16, ["prop", "rules"]),
          _renderSlot(_ctx.$slots, __props.prop + '-bottom-label', {
            formItem: __props.formItem,
            prop: __props.prop
          })
        ]),
        _: 3
      }, 16))
    : _createCommentVNode("", true)
}
}

})